// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"JoyLogo_wrapper__3ivfH","extension":"JoyLogo_extension__197gS"};